import { FC } from 'react';

interface ISvgProps {}

export const OtherFileIcon: FC<ISvgProps> = () => {
	return (
		<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M12 0.5H4C3.46957 0.5 2.96086 0.710714 2.58579 1.08579C2.21071 1.46086 2 1.96957 2 2.5V17.5C2 18.0304 2.21071 18.5391 2.58579 18.9142C2.96086 19.2893 3.46957 19.5 4 19.5H16C16.5304 19.5 17.0391 19.2893 17.4142 18.9142C17.7893 18.5391 18 18.0304 18 17.5V6.5L12 0.5Z"
				fill="#FFB400"
			/>
			<path
				d="M11.9961 5.49609V0.5L18 6.49609H12.9961C12.4438 6.49609 11.9961 6.04838 11.9961 5.49609Z"
				fill="#FFB400"
			/>
			<path
				d="M11.9961 5.49609V0.5L18 6.49609H12.9961C12.4438 6.49609 11.9961 6.04838 11.9961 5.49609Z"
				fill="black"
				fillOpacity={0.4}
			/>
			<path
				d="M7.26729 12.3015V11.6365H4.70229V14.9365H5.56229V13.6665H6.92229V13.0015H5.56229V12.3015H7.26729ZM8.79381 11.6365H7.93381V14.9365H8.79381V11.6365ZM10.5556 14.2715V11.6365H9.69561V14.9365H12.2106V14.2715H10.5556ZM13.7334 14.2715V13.5965H15.0934V12.9715H13.7334V12.3015H15.4434V11.6365H12.8734V14.9365H15.5084V14.2715H13.7334Z"
				fill="white"
			/>
		</svg>
	);
};
